module.exports = __webpack_public_path__ + "9488d02b/img/link-icon.fa09ed66.svg";